
export const getFormErrorState = state => state.formError;
export const getErrorIfShow = (state, { container, form, field }) => {
  const localState = getFormErrorState(state);
  if (localState.show) {
    if (container === 'forms') {
      return localState.forms[form][field];
    }
    if (container === 'delivery') {
      return localState.delivery[field];
    }
  }
  return undefined;
};

export const getValidating = state => getFormErrorState(state).validating;

export const hasError = (state) => {
  const localState = getFormErrorState(state);
  const hasFormError = Object.keys(localState.forms).reduce(
    (acc, key) => Object.keys(localState.forms[key]).reduce(
      (acc2, key2) => acc2 || Boolean(localState.forms[key][key2]),
      acc,
    ),
    false,
  );
  const hasDeliveryError = Object.keys(localState.delivery).reduce(
    (acc, key) => acc || Boolean(localState.delivery[key]),
    false,
  );
  const hasGeneralError = Boolean(localState.message);
  return hasFormError || hasDeliveryError || hasGeneralError;
};

export const getMessage = state => getFormErrorState(state).message;

export const getFormsError = state => getFormErrorState(state).forms;

export const getDeliveryError = state => getFormErrorState(state).delivery;
